import { Box, SlideFade, BoxProps } from '@wegroup/design-system';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useLocation } from 'react-router';
import ScrollDownButton from './ScrollDownButton';

interface Props {
  scrollContainer: HTMLDivElement;
  isScrollable: boolean;
  setIsScrollable: (arg0: boolean) => void;
}

const ScrollDownButtonContainer: React.FC<
  React.PropsWithChildren<Props & BoxProps>
> = ({ scrollContainer, isScrollable, setIsScrollable, ...props }) => {
  const location = useLocation();
  const formContext = useFormContext();

  useEffect(() => {
    scrollContainer?.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (scrollContainer?.scrollTop === 0) {
      setIsScrollable(
        (scrollContainer?.scrollHeight || 0) >
          (scrollContainer?.clientHeight || 0),
      );
    }
  }, [
    scrollContainer?.clientHeight,
    scrollContainer?.scrollHeight,
    location.pathname,
  ]);

  const handleClickScroll = () => {
    if (scrollContainer) {
      scrollContainer?.scrollTo({
        top: scrollContainer?.scrollTop + scrollContainer?.offsetHeight * 0.8,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Box
      position="fixed"
      w="44px"
      h="44px"
      bottom="24"
      right="4"
      zIndex="2"
      {...props}
    >
      <SlideFade
        in={isScrollable && !formContext?.formState.isSubmitting}
        offsetY="20px"
        unmountOnExit
      >
        <ScrollDownButton onClick={handleClickScroll} />
      </SlideFade>
    </Box>
  );
};

export default ScrollDownButtonContainer;
